export default __webpack_public_path__ + "static/media/Balancing_Tube_0_2ml_ST.3c09419f.svg";